/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import GuardianRouteLinkItem from './GuardianRouteLinkItem';
import DemographicsIcon from 'icons/DemographicsIcon';

const messages = defineMessages({
  title: {id: 'navigation.demographics'},
});

const DemographicsItem = () => (
  <GuardianRouteLinkItem
    iconBefore={DemographicsIcon}
    route="midas/guardian/demographics"
    title={messages.title}
  />
);

export default DemographicsItem;
